<template>
    <div class="nong-start">
        <div class="nong-start-box" ref="nongBox">
            <div v-show="gifShow">
                <img v-if="land=='zh-CN'" class="nong-start-img" src="../../assets/image/nong-ch.gif">
                <img v-else class="nong-start-img" src="../../assets/image/nong-en.gif">
            </div>
            <transition name="mybox">
                <div class="nong-start-div" v-show="textShow">
                    <img src="../../assets/image/home/homeTitleW.png">
                    <div class="nong-start-text"><span class="nong-main-zh" @click="clickCN">中文</span>|<span
                      class="nong-main-en" @click="clickEN">English</span></div>
                </div>
            </transition>
        </div>
        <div class="nong-start-foot">
            <div style="z-index: 999">ICP备案号：</div>
            <el-link type="info" @click="open">沪ICP备17014914号-1</el-link>
        </div>
    </div>
</template>

<script>
export default {
  name: "start",
  data(){
    return{
      land:'zh-CN',
      gifShow: false,
      textShow:true,
      isIosShow:false
    }
  },
  mounted() {
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      this.isIosShow = true
      this.$refs.nongBox.style.height = document.body.clientHeight + 'px'
    } else {
      this.isIosShow = false
    }

  },
  created(){
  },
  methods: {
    clickCN: function () {
      this.$i18n.locale = 'zh-CN'
      localStorage.setItem('locale', 'zh-CN');
      this.land='zh-CN'
      this.textShow=false
      setTimeout(() =>{
        this.gifShow = true
      },1200);
      // window.console.log(localStorage.getItem('locale'))
      setTimeout(() =>{
        this.$router.replace('/main')
      },9000);

    },

    clickEN: function () {
      this.$i18n.locale = 'en-US'
      localStorage.setItem('locale', 'en-US');
      this.land='en-US'
      this.textShow=false
      setTimeout(() =>{
        this.gifShow = true
      },1200);
      // window.console.log(localStorage.getItem('locale'))
      // this.$router.replace('/main')
      setTimeout(() =>{
        this.$router.replace('/main')
      },8000);
    },
    open() {
        window.open('http://beian.miit.gov.cn/')
    }
  },
}
</script>

<style scoped>
    @media screen and (min-width: 960px) {
        .nong-start{
            width: 100%;
            height: 100%;
            background-color: black;
        }

        .nong-start-box {
            width: 100%;
            height: calc(100% - 20px);
            z-index: 100;
            background-color: black;
            color: #535353;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .nong-start-foot {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 20px;
            background-color: #000000;
            font-family: sy-HanSansCN-Noraml;
            color: rgba(255,255,255,.5);
            font-size: 10px;
            justify-content: center;
            align-items: center;
        }

        /deep/.nong-start-foot .el-link--inner {
            font-family: sy-HanSansCN-Noraml;
            color: rgba(255,255,255,.5);
            font-size: 10px;
        }

        .nong-start-text {
            width: 140px;
            display: flex;
            justify-content: space-between;
            font-size:12px;
            font-weight:400;
            line-height:41px;
        }

        .nong-start-div{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .nong-start-div img{
            width: 145px;
            margin-bottom: 40px;
        }

        .nong-start-text span {
            cursor: pointer;
        }

        .nong-start-img {
            width: 600px;
        }

        .nong-main-zh {
            font-family: sy-HanSansCN-Noraml;
        }

        .nong-main-zh:hover {
            color: white;
        }

        .nong-main-en {
            font-family: Montserrat;
        }

        .nong-main-en:hover {
            color: white;
        }

        .mybox-leave-active, .mybox-enter-active {
            transition: all 1s ease;
        }

        .mybox-leave-active, .mybox-enter {
            opacity: 0 !important;
        }

        .mybox-leave, .mybox-enter-active {
            opacity: 500;
        }
    }

    @media screen and (max-width: 960px) {
      .nong-start{
        width: 100%;
        height: 100%;
        background-color: black;
      }
        /*.nong-start-box {*/
        /*    width: 100%;*/
        /*    height: 100%;*/
        /*    z-index: 100;*/
        /*    background-color: black;*/
        /*    color: #535353;*/
        /*    display: flex;*/
        /*    flex-direction: column;*/
        /*    align-items: center;*/
        /*    justify-content: center;*/
        /*}*/

      .nong-start-box {
        width: 100%;
        height: calc(100% - 20px);
        z-index: 100;
        background-color: black;
        color: #535353;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .nong-start-foot {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 20px;
        background-color: #000000;
        font-family: sy-HanSansCN-Noraml;
        color: rgba(255,255,255,.5);
        font-size: 10px;
        justify-content: center;
        align-items: center;
      }

        .nong-start-text {
            width: 140px;
            display: flex;
            justify-content: space-between;
            font-size:14px;
            font-weight:400;
            line-height:41px;
        }

        .nong-start-div{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .nong-start-div img{
            width: 180px;
            margin-bottom: 40px;
        }

        .nong-start-text span {
            cursor: pointer;
        }

        .nong-start-img {
            width: 100%;
            transform: scale(2);
        }

        .nong-main-zh {
            /*font-family: sy-HanSansCN-Noraml;*/
        }

        .nong-main-zh:hover {
            color: white;
        }

        .nong-main-en {
            font-family: Montserrat;
        }

        .nong-main-en:hover {
            color: white;
        }

        .mybox-leave-active, .mybox-enter-active {
            transition: all 1s ease;
        }

        .mybox-leave-active, .mybox-enter {
            opacity: 0 !important;
        }

        .mybox-leave, .mybox-enter-active {
            opacity: 500;
        }

        .nong-bottom {
            padding-bottom: 60px;
            box-sizing: border-box;
        }
    }

</style>
